export default __webpack_public_path__ + "static/media/VATCST-CST.1de4fd1f.xlsx";